/**
 * Network icon: central node with outer nodes, straight edge-to-edge lines.
 * Adjust SPREAD to change distance from center to outer nodes.
 */
const CX = 12;
const CY = 12;
const CENTER_R = 3;
const OUTER_R = 2;
/** Distance from center to each outer node center. Increase for more spacing. */
const SPREAD = 9;

const TOP = { cx: CX, cy: CY - SPREAD };
const RIGHT = { cx: CX + SPREAD, cy: CY };
const BOTTOM = { cx: CX, cy: CY + SPREAD };
const LEFT = { cx: CX - SPREAD, cy: CY };

/** Line from center circle edge to outer circle edge (no line through nodes). */
const line = (
  fromX: number,
  fromY: number,
  toX: number,
  toY: number
) => ({ fromX, fromY, toX, toY });

const lines = [
  line(CX, CY - CENTER_R, TOP.cx, TOP.cy + OUTER_R),       // center top -> top node bottom
  line(CX + CENTER_R, CY, RIGHT.cx - OUTER_R, RIGHT.cy),   // center right -> right node left
  line(CX, CY + CENTER_R, BOTTOM.cx, BOTTOM.cy - OUTER_R), // center bottom -> bottom node top
  line(CX - CENTER_R, CY, LEFT.cx + OUTER_R, LEFT.cy),     // center left -> left node right
];

interface NetworkIconProps {
  width?: number;
  height?: number;
}

/** Static track so the path is always visible; rail CSS can style it. */
const TRACK_CLASS = 'network-icon-track';
/** Moving dash "signal"; rail hover animates stroke-dashoffset. */
const LINE_CLASS = 'network-icon-line';

const DASH_LENGTH = 3;
const DASH_GAP = 3;

export function NetworkIcon({ width = 20, height = 20 }: NetworkIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx={CX} cy={CY} r={CENTER_R} />
      <circle cx={TOP.cx} cy={TOP.cy} r={OUTER_R} />
      <circle cx={RIGHT.cx} cy={RIGHT.cy} r={OUTER_R} />
      <circle cx={BOTTOM.cx} cy={BOTTOM.cy} r={OUTER_R} />
      <circle cx={LEFT.cx} cy={LEFT.cy} r={OUTER_R} />
      {lines.map((l, i) => (
        <g key={i}>
          <line
            className={TRACK_CLASS}
            x1={l.fromX}
            y1={l.fromY}
            x2={l.toX}
            y2={l.toY}
          />
          <line
            className={LINE_CLASS}
            x1={l.fromX}
            y1={l.fromY}
            x2={l.toX}
            y2={l.toY}
            strokeDasharray={`${DASH_LENGTH} ${DASH_GAP}`}
          />
        </g>
      ))}
    </svg>
  );
}
